import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const cyera = defineConnector({
  identifier: "cyera",
  name: "Cyera",
  tagLine: "Data security and governance",
  logo,
  protocol: "http",
  tags: ["security", "data"],
  defaultUrlPattern: () => "https://api\\.cyera\\.io/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create an OAuth app in Cyera",
      items: [
        {
          kind: "markdown",
          content: `1. Go to your [Cyera Settings page](https://app.cyera.io/settings/integrations)
2. Click "Create OAuth Application"
3. Enter an application name (e.g., "Conductor")
4. Add the redirect URI: \`{{redirectUri}}\`
5. Click "Create"
6. Copy the Client ID and Client Secret`,
        },
      ],
    },
    {
      title: "Enter OAuth credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your account",
      items: [
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://app.cyera.io/oauth/authorize",
    tokenEndpoint: () => "https://app.cyera.io/oauth/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
    scopes: () => ["read", "write"],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.cyera.io/v1/me",
  },
});
